import React from 'react';
import NumberFormat from 'react-number-format';

const CustomerDetailsCard = React.memo(function CustomerDetailsCard({ state, onChange, errors, customerType }) {
  return (
    <div className="rx-card">
      <div className="rx-card-line rx-cl-blue" />
      <div className="rx-card-hd">
        <span className="rx-card-ico rx-ico-blue"><i className="fas fa-user" /></span>
        <span className="rx-card-title">Customer Details &mdash; <i>{customerType}</i></span>
      </div>
      <div className="rx-card-body">
        <div className="rx-cols-2">
          <div className="rx-fg">
            <label>Passenger First Name</label>
            <input type="text" className="rx-ff" maxLength={50} value={state.paxFirstName} onChange={onChange} name="paxFirstName" placeholder="First name" />
            {errors.paxFirstName.length > 0 && <span className="rx-err">{errors.paxFirstName}</span>}
          </div>
          <div className="rx-fg">
            <label>Passenger Last Name</label>
            <input type="text" className="rx-ff" maxLength={50} value={state.paxLastName} onChange={onChange} name="paxLastName" placeholder="Last name" />
            {errors.paxLastName.length > 0 && <span className="rx-err">{errors.paxLastName}</span>}
          </div>
        </div>
        <div className="rx-cols-2">
          <div className="rx-fg">
            <label>Phone</label>
            <div className="rx-cols-phone">
              <input type="text" className="rx-ff" name="countryCodePhone" placeholder="+1" maxLength="2" title="Country Code" value={state.countryCodePhone} onChange={onChange} />
              <NumberFormat className="rx-ff" name="phoneNumber" placeholder="(000) 000-0000" title="Phone Number" value={state.phoneNumber} onChange={onChange} format="###-###-####" />
            </div>
          </div>
          <div className="rx-fg">
            <label>Mobile Number</label>
            <div className="rx-cols-phone">
              <input type="text" className="rx-ff" name="countryCode" placeholder="+1" maxLength="2" title="Country Code" value={state.countryCode} onChange={onChange} />
              <NumberFormat className="rx-ff" name="mobileNumber" placeholder="(000) 000-0000" title="Mobile Number" value={state.mobileNumber} onChange={onChange} format="(###) ###-####" />
            </div>
            {errors.mobileNumber.length > 0 && <span className="rx-err">{errors.mobileNumber}</span>}
          </div>
        </div>
        <div className="rx-fg">
          <label>Email</label>
          <input type="text" className="rx-ff" name="email" placeholder="example@domain.com" maxLength="100" title="Email" value={state.email} onChange={onChange} />
          {errors.email.length > 0 && <span className="rx-err">{errors.email}</span>}
        </div>
      </div>
    </div>
  );
});

export default CustomerDetailsCard;
